import * as React from 'react';
import ErrorTemplate from '../components/template/error/Error';

export type ErrorStatusCode = 400 | 401 | 403 | 404 | 500 | 502 | 503 | 504;

export interface Props {
  statusCode: ErrorStatusCode;
}

interface InitialProps {
  // tslint:disable-next-line: no-any
  res: any;
  // tslint:disable-next-line: no-any
  err: any;
}

class Error extends React.Component<Props> {
  // tslint:disable-next-line: no-any
  public static statusCode(res: any, err: any) {
    if (res) {
      return res.statusCode;
    }
    if (err) {
      return err.statusCode;
    }
    return undefined;
  }

  public static getInitialProps({ res, err }: InitialProps): Props {
    const statusCode = Error.statusCode(res, err);
    return { statusCode };
  }

  public render() {
    const { statusCode } = this.props;
    return <ErrorTemplate statusCode={statusCode} />;
  }
}

export default Error;
